module.exports = __webpack_public_path__ + "static/media/Deirdre Green Headshot 1a.5d404b68.png";